import Vue from 'vue';
import Vuex from 'vuex';
import { imgs } from './assets';

Vue.use(Vuex);

const state = {
  imgs,
  step: 0,
  currentPage: 'Load',
  isMobole : false,
  seriesType:'Selected'
};

export default new Vuex.Store({
  state,

  mutations: {
    setCurrentPage(state: any, pageName: string) {
      state.currentPage = pageName;
    },
    setMobile(state: any, type: Boolean){
      state.isMobole = type;
    },
    setSeriesType(state:any,type:string){
      state.seriesType = type;
    }
  },
  actions: {},
  modules: {},
});
